export default {
  id: "page5",
  header: "Informacje na temat zwyczajów kulinarnych i używanych produktów",
  show: "parseInt(values.ankieta_ciastaSelfCz)<6",
  questions: [
    {
      type: "justlabel",
      number: "17",
      label:
        "Jakie rodzaje <span class='has-text-danger'>ciast z samodzielnie dobranych składników</span> Pan(i) przygotowuje? Proszę o zaznaczenie ciast, do których dodaje Pani różne składniki typu mąka, proszek do pieczenia, cukier wanilinowy, drożdże do pieczenia, aromaty, ale też kremy w torebkach, masy (np. makowe), polewy, dekoracje itp. ",
      info:
        "Dla każdego rodzaju ciasta proszę zaznaczyć jedną odpowiedź TAK lub NIE."
    },
    {
      type: "choice_names",
      options: ["TAK", "NIE"],
      labelWidth: "is-three-fifths",
      topLine: true,
      bottomLine: true
    },
    {
      label: "Babka / ciasto ucierane - jak babki piaskowe, cytrynowe itp.",
      type: "radio",
      id: "kategoria1_babka",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Murzynek, ciasto czekoladowe",
      type: "radio",
      id: "kategoria1_murzynek",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Biszkopt / ciasto na bazie biszkoptu",
      type: "radio",
      id: "kategoria1_biszkopt",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Wypieki na bazie ciasta kruchego (ciasta, ciasteczka, babeczki)",
      type: "radio",
      id: "kategoria1_kruchaBaza",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Jabłecznik, szarlotka (również na cieście kruchym)",
      type: "radio",
      id: "kategoria1_jablecznik",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: 'Babeczki z ciasta "babkowego", muffinki',
      type: "radio",
      id: "kategoria1_muffinki",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Ciasto przekładane masami, kremami, bitą śmietaną",
      type: "radio",
      id: "kategoria1_ciastoKrem",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Karpatka",
      type: "radio",
      id: "kategoria1_karpatka",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Ciasto z owocami ułożonymi na upieczonym cieście",
      type: "radio",
      id: "kategoria1_ciastoOwoce",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Sernik pieczony",
      type: "radio",
      id: "kategoria1_sernikPieczony",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Piernik",
      type: "radio",
      id: "kategoria1_piernik",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Makowiec  / ciasto z makiem",
      type: "radio",
      id: "kategoria1_makowiec",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Sernik lub inne ciasta na zimno",
      type: "radio",
      id: "kategoria1_sernikZimny",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Ciasto drożdżowe ",
      type: "radio",
      id: "kategoria1_drozdzowe",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page5.js